import { EditOutlined, PersonOffOutlined, DeleteOutlined, MoreVert } from '@mui/icons-material';
import React, { useState, useRef, useEffect } from 'react';

interface UserActionsMenuProps {
  onEdit: () => void;
  onToggleActive: () => void;
  onDelete: () => void;
  isActive?: boolean;
}

export const UserActionsMenu: React.FC<UserActionsMenuProps> = ({
  onEdit,
  onToggleActive,
  onDelete,
  isActive,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleEdit = () => {
    setIsOpen(false);
    onEdit();
  };

  const handleToggleActive = () => {
    setIsOpen(false);
    onToggleActive();
  };

  const handleDelete = () => {
    setIsOpen(false);
    onDelete();
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
        title="Más acciones"
      >
        <MoreVert fontSize="small" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-10">
          <button
            onClick={handleEdit}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-3 transition-colors"
          >
            <EditOutlined fontSize="small" className="text-gray-500" />
            Editar Usuario
          </button>

          <button
            onClick={handleToggleActive}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-3 transition-colors"
          >
            <PersonOffOutlined fontSize="small" className="text-gray-500" />
            {isActive ? 'Desactivar' : 'Activar'} Usuario
          </button>

          <div className="border-t border-gray-200 my-1" />

          <button
            onClick={handleDelete}
            className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-3 transition-colors"
          >
            <DeleteOutlined fontSize="small" />
            Borrar Usuario
          </button>
        </div>
      )}
    </div>
  );
};
